export default __webpack_public_path__ + "static/media/signup-background.6cbc3e69.jpg";